export let api_url=process.env.REACT_APP_API ?? 'https://api.dubisign.org/api';
export let host_url=process.env.REACT_APP_HOST ?? 'https://api.dubisign.org/';
export let basename=process.env.BASENAME ?? '';
export let mapKey=process.env.REACT_APP_MAP_KEY ?? 'AIzaSyBVofSHmm5fYuCQFYHlNSltQJhVjAi1H80';
export let recaptcha_key='6LekDuciAAAAAFyKztKm16XYB3OWLcl6_Z9Voz0X';
export let recaptcha_secretKey='6LekDuciAAAAAKPVp1NDrjKZ_aceR6P9U25XmFBm';


console.log("process.env.REACT_APP_RECAPTCHA_SITEKEY", process.env.REACT_APP_RECAPTCHA_SITEKEY)
